import * as React from 'react';
import { StyleReset, StyleBase, Theme } from '@independent-software/typeui/styles';
import { ThemeProvider } from 'styled-components';
import { IThemeInterface } from '@independent-software/typeui/styles/Theme';

import { Auth } from './Auth';
import { AppContainer } from './AppContainer';

const MyTheme: IThemeInterface = {
  ...Theme,
  radius: 4
}

const Main = () => {
  // The loading screen (#apploader, with its spinner) stays up until <Auth>
  // has authenticated with Keycloak and fetched /me, at which point Auth removes
  // it. So Main deliberately doesn't touch the loader here.

  return (
    <>
      <StyleReset/>
      <StyleBase/>
      <ThemeProvider theme={MyTheme}>
        <Auth>
          <AppContainer/>
        </Auth>
      </ThemeProvider>
    </>
  );
}

export { Main }
